import React, { useState, useEffect, useRef } from 'react'
import { useTimer } from '../helpers/timer';
import IdleTimer from 'react-idle-timer'
import Modal from "../components/widgets/Modal";
import { logout } from '../actions/auth';
import { useDispatch } from 'react-redux';
import { AUTOLOGOUT_PROMPT_WAITING_SECONDS, LOGIN_STATUS, AUTOLOGOUT_EXPIRY_MINUTES } from '../constants';
import { getLoginStatus, setLoginStatus } from '../helpers/session';

const Autologout = ({ children }) => {
    const [show, setShow] = useState(false);
    const idleTimerRef = useRef(null);
    const dispatch = useDispatch();
    const autoLogoutPromptWaitingMs = AUTOLOGOUT_PROMPT_WAITING_SECONDS * 1000;
    const autoLogoutExpiryMs = AUTOLOGOUT_EXPIRY_MINUTES * 60 * 1000;
    const [timer, start, clear] = useTimer({ seconds: autoLogoutPromptWaitingMs, interval: 1000 });
    
    useEffect(() => {
        const documentVisibleStatus = document.visibilityState;
        const loginStatus = getLoginStatus();
        if (documentVisibleStatus === 'hidden' && loginStatus === LOGIN_STATUS.loggedIn){
            hideModal();
            handleContinue();
            idleTimerRef && idleTimerRef.current && idleTimerRef.current.reset();
            return;
        }
        if ((documentVisibleStatus === 'hidden' && loginStatus ===  LOGIN_STATUS.loggedOut) || timer <= 0 ){
            handleLogout(true);
        }
    }, [timer]);
    
    const handleOnIdle = () => {
            setLoginStatus(LOGIN_STATUS.loginIdle);
            setShow(true);
            start();
    }
    
    const hideModal = () => setShow(false);
    
    const handleContinue = () => {
        setLoginStatus(LOGIN_STATUS.loggedIn);
        clear();
    }
    const handleLogout = (isInactive) => {
        setShow(false);
        dispatch(logout({ inactive: Boolean(isInactive) }));
    }
    
    return (
        <>
            <IdleTimer
                ref={idleTimerRef}
                timeout={autoLogoutExpiryMs}
                onIdle={handleOnIdle}
                crossTab={{
                    emitOnAllTabs:true 
                }}
            />
            {children}
            {show && <Modal.Confirm
                title={{
                    content: 'Are you still there?'
                }}
                confirmButton={{
                    content: 'Stay here',
                    variant: 'primary',
                    className: 'logout-inactive-modal-btn'
                }}
                cancelButton={{
                    className: 'd-none'
                    }}
                show={show}
                className='logout-inactive-modal'
                onConfirm={handleContinue}
                iconClassName='fa fa-clock-o'
                onHide={hideModal}
                hideCloseIcon= {true}
                body={<>
                        Your session has been inactive for 2 hrs. For your security you will be automatically signed out in
                        <span className="d-block"><b>{timer / 1000}</b> seconds.</span>
                    </>}
                 />
            }
        </>
    )
}

export default Autologout;